import React from 'react'
import Card from '@components/Card'
import styled from 'styled-components/native'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST

const NoWorkOrdersText = styled.Text`
  font-style: italic;
  color: ${colors.gray[500]};
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`

const NoWorkOrdersNotice: React.VFC = () => {
  return (
    <Card>
      <NoWorkOrdersText>{COPY.NO_WORK_ORDERS}</NoWorkOrdersText>
    </Card>
  )
}

export default NoWorkOrdersNotice
